<dpqa-multi-select
  [value]="statusToDisplay()"
  (updateValue)="handleUpdateValue($event)"
  [options]="statuses"
  selectId="status-filter"
  [placeholder]="'FILTER_BAR.ALL' | translate"
  includeShowAll
/>
